// System
import { Button } from '@mui/material';
// Components
import FormProvider from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { UpdateMinesProviderConfigContent } from './UpdateMinesProviderConfigContent';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
// Form
import { useUpdateMinesProviderConfigForm } from '@Forms/providers/UpdateMinesProviderConfigFormContext';
// Redux
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useUpdateMinesProviderConfig } from '@Modal/hooks/providers/useUpdateMinesProviderConfig';

export const UpdateMinesProviderConfigForm = () => {
  const methods = useUpdateMinesProviderConfigForm();
  const { userPermissions } = useAuthorization();
  const canManageMinesProviderConfigs = userPermissions?.includes('CAN_MANAGE_PROVIDER_CONFIGS');
  const { handleUpdateCancel, handleSubmitUpdateMinesProviderConfig } =
    useUpdateMinesProviderConfig();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <UpdateMinesProviderConfigContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleUpdateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!canManageMinesProviderConfigs}
              onClick={handleSubmitUpdateMinesProviderConfig}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
